import { useCallback, useEffect, useState } from 'react';

const COOLDOWN_SECONDS = 60;

const storageKey = (email: string) =>
  `@cloudez-app/email-resend/${email.trim().toLowerCase()}`;

const readRemaining = (email: string) => {
  if (!email) return 0;

  try {
    const sentAt = Number(localStorage.getItem(storageKey(email)));
    const elapsed = Math.floor((Date.now() - sentAt) / 1000);
    return Math.max(COOLDOWN_SECONDS - elapsed, 0);
  } catch {
    return 0;
  }
};

// Guarda o horário do último envio por e-mail no localStorage, assim o
// bloqueio vale entre login e cadastro e sobrevive a um refresh da página.
export function useResendCooldown(email: string) {
  const [remaining, setRemaining] = useState(() => readRemaining(email));

  useEffect(() => {
    setRemaining(readRemaining(email));
  }, [email]);

  useEffect(() => {
    if (remaining <= 0) return undefined;

    const id = setTimeout(() => setRemaining(r => r - 1), 1000);
    return () => clearTimeout(id);
  }, [remaining]);

  const start = useCallback(
    (sentTo = email) => {
      try {
        localStorage.setItem(storageKey(sentTo), String(Date.now()));
      } catch {
        // sem storage o bloqueio fica só em memória
      }
      setRemaining(COOLDOWN_SECONDS);
    },
    [email],
  );

  return { remaining, start };
}
